import { Body } from "@vds/typography";
import { useSelector } from "react-redux";
import { GreyText } from "../../Rules/Rulesstyle";
import { getTagName } from "../../../model/reportService";

const getObjectNameFromCvAppList = (cvAppID, keyToCheck, cvAppList) => {
  const cvAppItem = cvAppList.find((item) => item?.id === cvAppID);
  return (
    (cvAppItem?.configtemplate?.schema?.properties["deploy-parameters"]
      ?.properties[keyToCheck]?.description
      ? cvAppItem?.configtemplate?.schema?.properties["deploy-parameters"]
        ?.properties[keyToCheck]?.description
      : cvAppItem?.configtemplate?.schema?.properties["deploy-parameters"]
        ?.properties[keyToCheck]?.title) ?? null
  );
};

export const StatisticsAccordion = ({
  newListTotal,
}) => {
  const tagIdList = useSelector((state) => {
    return state.sitesReducer.tagIdList;
  });

  const roiList = useSelector((state) => {
    return state.polygonRoiReducer?.roiListWithCvapps;
  });
  const cvAppsFromReducer = useSelector(
          (state) => state.cvAppReducer.cvAppList
        ) || [];

  const alertRoiDetail = roiList?.find(item => item?.id === newListTotal?.roiId);
  const locationDetailList = alertRoiDetail?.customdata?.statisticstagids ?? alertRoiDetail?.tagids;
  console.log(locationDetailList);
  const newList = newListTotal?.deploymentConfig
  const deployParameters =
    newList &&
    newList[0]?.config?.["deploy-parameters"];
  return (

    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      {Array.isArray(newList) &&
        newList.length > 0 &&
        deployParameters && "zone1" in deployParameters &&
        "zone2" in deployParameters ?
        Object.entries(newList[0].config["deploy-parameters"]).map(
          ([key, value]) => {
            let newValue;
            if (Array.isArray(value)) {
              let message = "";
              value.forEach((e, index) => {
                message =
                  message +
                  e +
                  `${index === value.length - 1 ? "" : ", "}`;
              });
              newValue = message;
            } else {
              newValue = value;
            }
            let newKey =
              getObjectNameFromCvAppList(newList?.appid, key, cvAppsFromReducer) ?? key;
            return (
              <div
                key={key}
                style={{
                  display: "flex",
                  fontSize: "16px",
                  gap: "0.5rem",
                }}
              >
                <GreyText
                  bold
                  size="large"
                  style={{
                    background: `${newKey === "zone1"
                      ? "#ff0000"
                      : newKey === "zone2"
                        ? "#0089ecb2"
                        : "none"
                      }`,
                    color: `${newKey === "zone1" || newKey === "zone2"
                      ? "#ffffff"
                      : "#6f7171"
                      }`,
                    padding: `${newKey === "zone1" || newKey === "zone2"
                      ? "5px 10px"
                      : "0px"
                      }`,
                  }}
                >
                  {newKey === "zone1"
                    ? "Zone 1"
                    : newKey === "zone2"
                    && "Zone 2"
                  }
                </GreyText>
                <Body size="large">
                  <span style={{ position: "relative", top: "6px" }}>
                    {newKey === "zone1"
                      ? getTagName(newValue, tagIdList) : newKey === "zone2" && getTagName(newValue, tagIdList)}

                  </span>
                </Body>
              </div>
            );
          }
        )
        : locationDetailList ?
          (locationDetailList?.map((item, index) => {
          if (newListTotal.deviceLoc.site.tag !== item) {
            return (
              <Body key={index} size="large">
                <span style={{ position: "relative", top: "6px" }}>
                  {getTagName(item, tagIdList)}
                </span>
              </Body>

            )
          }
        })) : <Body size="large">App Undeployed</Body>
      }
    </div>

  );
};

export default StatisticsAccordion

